{
  "help": "ヘルプ",
  "info": "情報"
}
